export default __webpack_public_path__ + "static/media/DefaultGoGetter.c206c75d.svg";